var map = {
	"./ic-announcement-inactive.svg": "e1b2",
	"./ic-devices-inactive.svg": "ded8",
	"./ic-layouts-inactive.svg": "63ad",
	"./ic-media-inactive.svg": "b263",
	"./ic-playlists-inactive.svg": "a7b4",
	"./ic-screens-inactive.svg": "e072",
	"./ic-smartplug-inactive.svg": "1bf9",
	"./ic-stats-inactive.svg": "7f7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28a0";